module.exports = __webpack_public_path__ + "img/resource-pro.d82889d6.png";